import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { TranslationKey } from "./resources";

export const translate = (key: TranslationKey) => i18next.t(`${key}.text`);

export const useAppTranslation = () => {
  const translation = useTranslation();

  const t = (key: TranslationKey, options: {} = {}) =>
    translation.t(`${key}.text`, options);

  return { ...translation, t };
};
